// $FlowFixMe
import SpatialNavigation from '../../libs/spatial-navigation';
import Platform from '../../platform';
import keys from '../../config/keys';

class SpatialNavigationWrapper {
  focusedPath;
  constructor() {
    this.destroy();
  }

  init() {
    document.addEventListener('mousedown', (e) => {
      if (e.target.tagName !== 'A') {
        e.preventDefault();
      }
    });
    SpatialNavigation.init(this.getInitParameters());
    SpatialNavigation.focus();
  }

  getInitParameters() {
    return {
      enterMapping: Platform.getKeyCode(keys.ENTER),
      keyMapping: Platform.navigationKeys,
    };
  }

  destroy() {
    this.focusedPath = '';

    SpatialNavigation.uninit();
  }

  focus(item) {
    SpatialNavigation.focus(item);
    return this;
  }

  set(sectionId, config) {
    SpatialNavigation.set(sectionId, config);
  }

  canFocusNext(direction) {
    const currentFocusedElement = document.activeElement;
    const currentSectionId = SpatialNavigation.getSectionId(currentFocusedElement);
    // When we have no currentSectionId it means app isn't rendered yet
    if (!currentSectionId) return false;

    const next = SpatialNavigation.focusNext(
      direction,
      currentFocusedElement,
      currentSectionId,
      true,
    );

    return !!next;
  }

  pauseNavigation() {
    SpatialNavigation.pause();
  }

  resumeNavigation() {
    SpatialNavigation.resume();
  }
  getCurrentFocusedPath() {
    return this.focusedPath;
  }

  setCurrentFocusedPath(focusPath) {
    this.focusedPath = focusPath;
  }

  addFocusable = (focusDOMElement, options) => {
    const { config = {}, id, defaultSection = false, setAutoFocus = true, sectionName } = options;

    if (!focusDOMElement || SpatialNavigation.getSectionId(focusDOMElement)) {
      return SpatialNavigation.getSectionId(focusDOMElement);
    }

    let selector = [...focusDOMElement.querySelectorAll('[data-nav-item]')];

    if (id) {
      selector = `#${id} [data-nav-item]`;
    }

    const params = {
      selector,
      ...config,
    };

    const sectionId = sectionName || SpatialNavigation.generateId();

    const section = SpatialNavigation.add(sectionId, { ...params });

    if (defaultSection) {
      SpatialNavigation.setDefaultSection(section);
      if (setAutoFocus) SpatialNavigation.focus(section);
    }

    SpatialNavigation.makeFocusable(section);

    return sectionId;
  };

  removeFocusable(sectionId) {
    SpatialNavigation.remove(sectionId);
  }

  move(direction, selector) {
    SpatialNavigation.move(direction, selector);
  }
}

export default new SpatialNavigationWrapper();
